document.addEventListener('DOMContentLoaded', async function() {
    const locationDropdown = document.querySelector('.location-dropdown');
    const pageLoader = document.querySelector('.page-loader');
    const errorNotification = document.querySelector('.error-notification');
    const errorMessage = document.querySelector('.error-notification-message');
    const errorCloseBtn = document.querySelector('.error-notification-close');
    const companyDropdown = document.querySelector('.company-dropdown');
    const baseURL = window.globalVariables.api_url;
    const fetchCompanyURL = `${baseURL}/customer/profile`;
    let errorTimeout;
  
    const CACHE_KEY = 'companiesData';
  
    function showError(message) {
        errorMessage.textContent = message;
        errorNotification.classList.add('show');
        
        if (errorTimeout) {
            clearTimeout(errorTimeout);
        }
        
        errorTimeout = setTimeout(() => {
            errorNotification.classList.remove('show');
        }, 5000);
    }
  
    function getCachedCompanies() {
        const cached = localStorage.getItem(CACHE_KEY);
        return cached ? JSON.parse(cached) : null;
    }
  
    function cacheCompanies(companies) {
        localStorage.setItem(CACHE_KEY, JSON.stringify(companies));
    }
  
    function compareCompanyIds(cachedCompanies, liveCompaniesString) {
        try {
            // Clean up the string and split it into array
            // Remove any backticks if present and extra spaces
            const cleanString = liveCompaniesString.replace(/`/g, '').trim();
            // Split the string by commas and clean up each item
            const liveCompanies = cleanString.split(',')
                .map(item => item.trim().replace(/"/g, '').replace('[', '').replace(']', ''));
          
            // Extract IDs from cached companies
            const cachedIds = new Set(cachedCompanies.map(company => company.companyId.toString()));
  
            // Extract IDs from live companies string and compare
            const liveIds = liveCompanies.map(companyString => {
                const matches = companyString.match(/Company\/(\d+)$/);
                return matches ? matches[1] : null;
            }).filter(id => id !== null);
  
            console.log(liveCompanies, cachedIds, liveIds);
  
            // Check if arrays have the same length and all IDs match
            if (liveIds.length !== cachedIds.size) {
                return false;
            }
  
            return liveIds.every(id => cachedIds.has(id));
        } catch (error) {
            console.error('Error comparing company IDs:', error);
            if (typeof Sentry !== 'undefined') {
                Sentry.captureException(error, { tags: { feature: 'company-cache-compare' } });
            }
            return false; // If there's any error in comparison, return false to trigger API call
        }
    }
  
    async function fetchCompanies() {
        if (typeof Sentry !== 'undefined') {
            Sentry.addBreadcrumb({ category: 'company', message: 'Fetching companies list', level: 'info' });
        }
        const response = await window.authFetch(fetchCompanyURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch companies. Status: ${response.status}`);
        }

        const companiesData = await response.json();
        const companies = companiesData?.canOrderFor;
        if (typeof Sentry !== 'undefined') {
            Sentry.addBreadcrumb({ category: 'company', message: `Fetched ${companies?.length || 0} companies`, level: 'info' });
        }
        cacheCompanies(companies);
        return companies;
    }
  
    function renderCompanies(companies, dropdownContent, currentCompanyName) {
        // Clear existing content
        dropdownContent.innerHTML = '';
        
        // Add companies to dropdown
        companies.forEach(company => {
            const isActive = company.id === parseInt(currentCompanyName?.getAttribute('data-current-company-id'));
            const companyElement = document.createElement('a');
            companyElement.className = `company-option cursor-pointer ${isActive ? 'active' : ''}`;
            companyElement.setAttribute('data-company-id', company.companyId);
            companyElement.setAttribute('data-company-name', company.companyName);
            companyElement.textContent = company.companyName;
            dropdownContent.appendChild(companyElement);
  
            // Add click handler for this company option
            companyElement.addEventListener('click', async function(e) {
                const newCompanyId = this.getAttribute('data-company-id');
                const newCompanyName = this.getAttribute('data-company-name');

                if (typeof Sentry !== 'undefined') {
                    Sentry.addBreadcrumb({
                        category: 'company',
                        message: `Switching company to "${newCompanyName}" (${newCompanyId})`,
                        level: 'info',
                        data: { companyId: newCompanyId, companyName: newCompanyName },
                    });
                }

                try {
                    pageLoader.classList.add('active');

                    const updateResponse = await window.authFetch(`${baseURL}/customer/companies`, {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            companyId: parseInt(newCompanyId)
                        }),
                        redirect: "follow" 
                    });
  
                    if (!updateResponse.ok) {
                        throw new Error(`Failed to update company. Status: ${updateResponse.status}`);
                    }
  
                    const result = await updateResponse.json();
                    console.log("Update successful:", result);

                    if (typeof Sentry !== 'undefined') {
                        Sentry.addBreadcrumb({
                            category: 'company',
                            message: `Company switch successful to "${newCompanyName}"`,
                            level: 'info',
                        });
                    }

                    if(currentCompanyName) {
                        currentCompanyName.innerHTML = newCompanyName;
                    }

                    window.location.href = "https://shopify.com/70395527401/account/locations?return_to=/";
                } catch (error) {
                    console.error("Failed to update company:", error);
                    if (typeof Sentry !== 'undefined') {
                        Sentry.captureException(error, {
                            extra: { companyId: newCompanyId, companyName: newCompanyName },
                            tags: { feature: 'company-switch' },
                        });
                    }
                    showError("Failed to switch company. Please try again later.");

                    if(currentCompanyName) {
                        currentCompanyName.innerHTML = currentCompanyName.getAttribute('data-current-company-name');
                    }
                    pageLoader.classList.remove('active');
                }
            });
        });
    }
  
    errorCloseBtn?.addEventListener('click', () => {
        errorNotification.classList.remove('show');
        if (errorTimeout) {
            clearTimeout(errorTimeout);
        }
    });
  
    if (locationDropdown) {
        locationDropdown?.addEventListener('click', function(e) {
            e.stopPropagation();
            this?.classList.toggle('active');
        });
  
        document.addEventListener('click', function(e) {
            if (!locationDropdown?.contains(e.target)) {
                locationDropdown?.classList.remove('active');
            }
        });
    }
  
    // Company Dropdown Handler
    if (companyDropdown) {
        const dropdownContent = companyDropdown.querySelector('[data-company-list]');
        const currentCompanyName = document.querySelector('[data-new-company-name]');
        const liveCompaniesData = companyDropdown.getAttribute('data-live-companies');
        
        try {
            // Try to get companies from cache first
            let companies = getCachedCompanies();
            
            // Check if we need to fetch fresh data
            if (!companies || !compareCompanyIds(companies, liveCompaniesData)) {
                companies = await fetchCompanies();
            }
            
            renderCompanies(companies, dropdownContent, currentCompanyName);
  
            // Add click handlers for dropdown
            companyDropdown.addEventListener('click', function(e) {
                e.stopPropagation();
                this.classList.toggle('active');
            });
  
            document.addEventListener('click', function(e) {
                if (!companyDropdown.contains(e.target)) {
                    companyDropdown.classList.remove('active');
                }
            });
  
        } catch (error) {
            console.error("Failed to fetch companies:", error);
            if (typeof Sentry !== 'undefined') {
                Sentry.captureException(error, { tags: { feature: 'company-fetch' } });
            }
            showError("Failed to load companies. Please refresh the page.");
        } finally {
            pageLoader.classList.remove('active');
        }
    }
  });